import React, { useEffect, useState } from 'react'
import NavBar from './NavBar'

import { connect } from 'react-redux'

import { useSpotify } from '../../hoc/context/SpotifyContextContainer'
import { makeSpotifyRequest } from '../../config/SpotifyRequests'

import { setPlaylists as sp } from '../../actions/index'


function NavBarContainer({alert, dispatch}) {

    const { accessToken } = useSpotify() 
    const [ playlists, setPlaylists ] = useState([])

    useEffect(() => {
        
        makeSpotifyRequest(`https://api.spotify.com/v1/me/playlists`, accessToken).then(response => {
            const data = response.data.items;
            setPlaylists(pre => [...data])
            dispatch(sp(data))
        })
    }, [alert])

    return (
        <>
            <NavBar playlists={playlists}/>
        </>
    )
}

function mapStateToProps(state){
    return {
        playlists: state.playlists
    }
}

export default connect(mapStateToProps)(NavBarContainer);